
var viewsizeClasses = {
    go: function () {

        // jQuery global vars
        var $window = $(window);
        var $body = $('#kit-body');        

        // non JQuery global vars
        var resizeTimer;
        var resizeDelay = 200;

        // --------------------------------------------------------------------
        // on document ready
        // --------------------------------------------------------------------

        $(function () {
            AddViewsizeClass();
        });

        // --------------------------------------------------------------------
        // on window resize
        // --------------------------------------------------------------------

        $window.on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                // executes after window resize has finished
                AddViewsizeClass();
                // throw event
                $body.trigger("viewsizeChanged");
            }, resizeDelay);
        });

        // --------------------------------------------------------------------
        // functions
        // --------------------------------------------------------------------

        // set viewsize body classes
        function AddViewsizeClass() {
            if ($('.kit-indicator--sm').is(':visible')) {
                $body.addClass('is-sm');
            } else {
                $body.removeClass('is-sm');
            }
            if ($('.kit-indicator--md').is(':visible')) {
                $body.addClass('is-md');
            } else {
                $body.removeClass('is-md');
            }
            if ($('.kit-indicator--lg').is(':visible')) {
                $body.addClass('is-lg');
            } else {
                $body.removeClass('is-lg');
            }
            if ($('.kit-indicator--xl').is(':visible')) {
                $body.addClass('is-xl');
            } else {
                $body.removeClass('is-xl');
            }
        }
    }
}
viewsizeClasses.go();
